import { CoreLogService } from "../log.service";
import { environment } from "../../../../environments/environment";
import { StatusBarTextStyle } from "../../shared/contentTypes";

declare var StatusBar: any;

export interface ICordovaStatusBar {
  overlaysWebView(isOverLay: boolean): Promise<void>;
  styleDefault(): Promise<void>;
  styleLightContent(): Promise<void>;
  styleBlackTranslucent(): Promise<void>;
  styleBlackOpaque(): Promise<void>;
  backgroundColorByName(colorName: string): Promise<void>;
  backgroundColorByHexString(hexColor: string): Promise<void>;
  hide(): Promise<void>;
  show(): Promise<void>;
  setStatusBarTextstyle(): Promise<void>;
}

export class CordovaStatusBar implements ICordovaStatusBar {

  private _isVisible: boolean;

  constructor(private _coreLogService: CoreLogService) {

  }

  public get IsVisible(): boolean {
    return this._isVisible;
  }
/**
 * Make the statusbar overlay or not overlay the WebView
 * @param isOverLay Set to true to make the statusbar overlay on top of your app
 */
  public overlaysWebView(isOverLay: boolean): Promise<void> {
    const me = this;
    try {
      if (StatusBar) {
        StatusBar.overlaysWebView(isOverLay);
      }
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "overlaysWebView()", error);
      return Promise.reject();
    }
  }

  /** Use the default statusbar (dark text, for light backgrounds) */
  public styleDefault(): Promise<void> {
    const me = this;
    try {
      if (StatusBar) {
        StatusBar.styleDefault();
      }
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "styleDefault()", error);
      return Promise.reject();
    }
  }

  /** Use the lightContent statusbar (light text, for dark backgrounds) */
  public styleLightContent(): Promise<void> {
    const me = this;
    try {
      if (StatusBar) {
        StatusBar.styleLightContent();
      }
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "styleLightContent()", error);
      return Promise.reject();
    }
  }

  /** Use the blackTranslucent statusbar (light text, for dark backgrounds) */
  public styleBlackTranslucent(): Promise<void> {
    const me = this;
    try {
      StatusBar.styleBlackTranslucent();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "styleBlackTranslucent()", error);
      return Promise.reject();
    }
  }
/** Use the blackOpaque statusbar (light text, for dark backgrounds) */
  public styleBlackOpaque(): Promise<void> {
    const me = this;
    try {
      StatusBar.styleBlackOpaque();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "styleBlackOpaque()", error);
      return Promise.reject();
    }
  }
/**
 * when you set StatusBar.overlaysWebView to false, you can set the background color of the statusbar by color name
 * @param colorName Color Name eg: 'red'
 */
  public backgroundColorByName(colorName: string): Promise<void> {
    const me = this;
    try {
      StatusBar.backgroundColorByName(colorName);
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "backgroundColorByName()", error);
      return Promise.reject();
    }
  }

  public backgroundColorByHexString(hexColor: string): Promise<void> {
    const me = this;
    try {
      StatusBar.backgroundColorByHexString(hexColor);
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "backgroundColorByHexString()", error);
      return Promise.reject();
    }
  }

  public hide(): Promise<void> {
    const me = this;
    try {
      StatusBar.hide();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "hide()", error);
      return Promise.reject();
    }
  }

  public show(): Promise<void> {
    const me = this;
    try {
      StatusBar.show();
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "show()", error);
      return Promise.reject();
    }
  }

  /**
   * set StatusBarText base on StatusBarTextStyle variable in environmet
   */
  public setStatusBarTextstyle(): Promise<void> {
    const me = this;
    try {
      switch (environment.StatusBarTextStyle) {
        case StatusBarTextStyle.styleDefault:
          me.styleDefault();
          break;
        case StatusBarTextStyle.styleBlackOpaque:
          me.styleBlackOpaque();
          break;
        case StatusBarTextStyle.styleBlackTranslucent:
          me.styleBlackTranslucent();
          break;
        case StatusBarTextStyle.styleLightContent:
          me.styleLightContent();
          break;
        default:
          me.styleDefault(); // fallback
          me._coreLogService.error("CordovaStatusBar", "setStatusBarTextstyle", "No StatusBarTextStyle found!");
          break;
      }
      return Promise.resolve();
    } catch (error) {
      me._coreLogService.error("CordovaStatusBar", "setStatusBarTextstyle", error);
      return Promise.reject();
    }
  }

}
